import { isNil, isNumeric } from './xp.v1'

// 动作派发
function dispatchSync(pathName) {
  return ({ dispatch }, args) =>
    dispatch(pathName, args, {
      root: true
    })
}

function dispatchAsync(pathName) {
  return async (opts, args) => {
    const { dispatch } = opts
    const R = await dispatch(pathName, args, {
      root: true
    })
    return R
  }
}

// 快捷方式：提交
function shortCommit(pathName) {
  return ({ commit }, args) =>
    commit(pathName, args, {
      root: true
    })
}

// 快捷读取
function _pathValue(state, paths, defaultValue) {
  const maxIndex = paths.length - 1
  const attrName = paths[maxIndex]
  if (attrName) {
    for (let i = 0; i < maxIndex; i++) {
      state = state[paths[i]]
      if (isNil(state)) {
        return defaultValue
      }
    }
    const value = state[attrName]
    return isNil(value) ? defaultValue : value
  }
  return defaultValue
}

function shortRootState(pathKey, defaultValue) {
  const paths = pathKey.split('/')
  return (_state, _getters, rootState) =>
    _pathValue(rootState, paths, defaultValue)
}

// 数字值
function shortRootStateN(pathKey, defaultValue) {
  defaultValue = isNumeric(defaultValue) ? +defaultValue : 0
  const getFn = shortRootState(pathKey, defaultValue)
  return (state, getters, rootState) => {
    const value = getFn(state, getters, rootState)
    return isNumeric(value) ? +value : defaultValue
  }
}

function shortRootGetter(pathKey, defaultValue) {
  return (_state, _getters, _rootState, rootGetters) => {
    const value = rootGetters[pathKey]
    return isNil(value) ? defaultValue : value
  }
}

function shortState(pathKey, defaultValue) {
  return state => _pathValue(state, pathKey.split('/'), defaultValue)
}
function shortStateN(pathKey, defaultValue) {
  defaultValue = isNumeric(defaultValue) ? +defaultValue : 0
  const getFn = shortState(pathKey, defaultValue)
  return state => {
    const value = getFn(state)
    return isNumeric(value) ? +value : defaultValue
  }
}

export {
  // 快捷方式：动作派发
  dispatchSync,
  dispatchAsync,
  
  // 快捷提交：rootState
  shortCommit,
  
  // 快捷读取：rootState
  shortRootState,
  shortRootStateN,
  shortRootGetter,
  
  // 快捷读取: 当前模块的state 子属性值
  shortState,
  shortStateN
}
